// extracted by mini-css-extract-plugin
export default {"checkboxDummy":"HeaderRow_checkboxDummy__l3Z7X","placeHolderShimmer":"HeaderRow_placeHolderShimmer__-jPMq"};